import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const RelatedServices = [
  { title: 'Title Searches', path: '/services/title-searches' },
  { title: 'Title Insurance', path: '/services/title-insurance' },
  { title: 'Residential Settlements', path: '/services/residential-settlements' },
  { title: 'Commercial Closings', path: '/services/commercial-closings' },
];

const LienSearchesPage = () => {
  return (
    <>
      <head>
        <title>Lien Searches Bucks County PA | Black Dog Settlement</title>
        <meta name="description" content="Comprehensive lien searches for residential and commercial properties in Bucks, Montgomery, Chester, and Delaware County, PA. Federal, state, judgment, and mechanic's liens. Call 215-499-0796." />
        <meta name="keywords" content="lien search Bucks County PA, property lien search Newtown PA, mechanic lien search Montgomery County, judgment lien Chester County Pennsylvania" />
        <link rel="canonical" href="https://www.blackdogsettlement.com/services/lien-searches" />
        <meta name="geo.region" content="US-PA" />
        <meta name="geo.placename" content="Newtown, Pennsylvania" />
        <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@600;700;800;900&family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet" />
      </head>
      <div style={{ fontFamily: "'Inter', sans-serif" }}>
        <Navbar />
        <section className="bg-[#0f0f0f] pt-36 pb-20">
          <div className="max-w-7xl mx-auto px-6 md:px-12">
            <div className="flex items-center gap-2 text-stone-500 text-xs mb-8">
              <Link to="/" className="hover:text-[#c9a84c] cursor-pointer">Home</Link>
              <i className="ri-arrow-right-s-line"></i>
              <Link to="/services" className="hover:text-[#c9a84c] cursor-pointer">Services</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-white/40">Lien Searches</span>
            </div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-8 h-px bg-[#c9a84c]"></div>
              <span className="text-[#c9a84c] text-xs font-bold tracking-[0.3em] uppercase">Service</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-black text-white leading-tight mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Lien<br /><span className="text-[#c9a84c]">Searches</span>
            </h1>
            <p className="text-white/40 text-base leading-relaxed max-w-xl">
              Comprehensive lien searches to identify any outstanding claims against a property before closing — protecting buyers, sellers, and lenders.
            </p>
          </div>
        </section>
        <section className="bg-white py-20">
          <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col lg:flex-row gap-16">
            <div className="w-full lg:w-[65%]">
              <h2 className="text-3xl font-black text-[#0f0f0f] mb-5" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Uncover Hidden Claims Before You Close</h2>
              <div className="space-y-4 text-stone-500 text-sm leading-relaxed mb-10">
                <p>A lien is a legal claim against a property, typically used as security for a debt. If a property has outstanding liens at the time of sale, those liens can transfer to the new owner — creating serious financial and legal problems. Black Dog Settlement conducts thorough lien searches to identify any claims before closing.</p>
                <p>We search federal and state records, county court records, and municipal databases to uncover all types of liens on properties throughout Bucks, Montgomery, Chester, and Delaware County, PA. Our comprehensive searches give buyers, sellers, and lenders the confidence to proceed with their transactions.</p>
              </div>
              <h3 className="text-xl font-black text-[#0f0f0f] mb-5" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Types of Liens We Search</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-10">
                {['Federal tax liens (IRS)', 'State tax liens (PA DOR)', 'Judgment liens', "Mechanic's & contractor liens", 'HOA & condo association liens', 'Municipal utility liens', 'Child support liens', 'Mortgage & deed of trust liens', 'Environmental liens', 'Municipal code violation liens'].map((item) => (
                  <div key={item} className="flex items-center gap-3 text-sm text-stone-600 border border-stone-100 px-4 py-3">
                    <div className="w-4 h-4 flex items-center justify-center shrink-0"><i className="ri-check-line text-[#c9a84c]"></i></div>
                    {item}
                  </div>
                ))}
              </div>
            </div>
            <div className="w-full lg:w-[35%] space-y-6">
              <div className="bg-[#0f0f0f] p-8">
                <h3 className="text-white text-xl font-black mb-3" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Order a Lien Search</h3>
                <p className="text-white/40 text-sm mb-6">Contact us to order a comprehensive lien search for your Bucks, Montgomery, Chester, or Delaware County property.</p>
                <a href="tel:2154990796" className="flex items-center justify-center gap-2 w-full bg-[#c9a84c] hover:bg-[#b8963e] text-[#0f0f0f] font-bold py-3.5 text-xs tracking-[0.15em] uppercase whitespace-nowrap cursor-pointer transition-colors mb-3">
                  <div className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-line"></i></div>
                  Call 215-499-0796
                </a>
                <Link to="/contact" className="flex items-center justify-center w-full border border-white/20 hover:border-white/50 text-white font-bold py-3.5 text-xs tracking-[0.15em] uppercase whitespace-nowrap cursor-pointer transition-colors">
                  Send a Message
                </Link>
              </div>
              <div className="border border-stone-100 p-6">
                <h4 className="text-xs font-bold tracking-[0.2em] uppercase text-stone-400 mb-4">Related Services</h4>
                <div className="space-y-2">
                  {RelatedServices.map((s) => (
                    <Link key={s.path} to={s.path} className="flex items-center justify-between py-2.5 border-b border-stone-100 last:border-0 text-sm text-[#0f0f0f] hover:text-[#c9a84c] transition-colors cursor-pointer group">
                      {s.title}
                      <div className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-xs text-stone-300 group-hover:text-[#c9a84c] transition-colors"></i></div>
                    </Link>
                  ))}
                </div>
              </div>
              <div className="bg-[#f7f5f0] p-6 space-y-3">
                <p className="text-xs font-bold tracking-[0.2em] uppercase text-stone-400 mb-4">Contact Info</p>
                <div className="flex items-center gap-3 text-sm text-stone-500"><div className="w-4 h-4 flex items-center justify-center shrink-0"><i className="ri-map-pin-2-line text-[#c9a84c]"></i></div>842 Durham Rd, Newtown, PA 18940</div>
                <div className="flex items-center gap-3 text-sm text-stone-500"><div className="w-4 h-4 flex items-center justify-center shrink-0"><i className="ri-time-line text-[#c9a84c]"></i></div>Mon–Fri: 9AM–5PM</div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};

export default LienSearchesPage;
